import { Instagram } from "lucide-react";
import { useLang } from "../../i18n";
import { Reveal, Overline } from "./Reveal";
import { CHEFS } from "../../data";

export const Exhibitors = () => {
  const { lang, t } = useLang();

  return (
    <section id="exhibitors" data-testid="exhibitors-section" className="bg-cream py-24 md:py-36">
      <div className="mx-auto max-w-[1440px] px-6 md:px-14">
        <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
          <Reveal>
            <Overline>{t.exhibitors.overline}</Overline>
            <h2 className="mt-5 max-w-2xl font-serif text-4xl font-medium leading-[1.05] tracking-tight text-ink md:text-6xl">
              {t.exhibitors.title}
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="max-w-xs text-sm leading-relaxed text-ink/55">{t.exhibitors.note}</p>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-2 gap-x-4 gap-y-12 md:grid-cols-3 md:gap-x-6 lg:grid-cols-4">
          {CHEFS.map((chef, i) => (
            <Reveal key={chef.name} delay={(i % 4) * 0.07}>
              <article data-testid={`chef-card-${i}`} className="group">
                <div className="spotlight relative overflow-hidden bg-parchment">
                  <img
                    src={chef.img}
                    alt={chef.name}
                    loading="lazy"
                    className="aspect-[3/4] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-gold transition-[width] duration-500 ease-out group-hover:w-full" />
                </div>
                <h3 className="mt-4 font-serif text-xl font-semibold leading-tight text-ink">{chef.name}</h3>
                <p className="mt-1 text-[13px] italic leading-snug text-panettone">{chef.spec[lang]}</p>
                {chef.ig && (
                  <a
                    href={`https://www.instagram.com/${chef.ig}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`chef-ig-${i}`}
                    className="mt-2 inline-flex items-center gap-1.5 break-all text-[11px] font-medium uppercase tracking-[0.12em] text-ink/45 transition-colors duration-300 hover:text-panettone"
                  >
                    <Instagram size={12} /> @{chef.ig}
                  </a>
                )}
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-16 flex justify-center">
            <a
              href="#participate"
              data-testid="exhibitors-cta"
              className="border border-ink/30 px-10 py-4 text-[12px] font-semibold uppercase tracking-[0.2em] text-ink transition-colors duration-500 hover:border-panettone hover:bg-panettone hover:text-cream"
            >
              {t.exhibitors.cta}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
